import { ErrorLike } from '@apollo/client';
import { useEffect, useState } from 'react';

export const useRefetchOnError = (
  retries: number,
  refetch: () => Promise<any>,
  error: ErrorLike | undefined,
) => {
  const [refetchCount, setRefetchCount] = useState(0);

  useEffect(() => {
    if (error && refetchCount < retries) {
      void refetch();

      setRefetchCount((prev) => prev + 1);

      return;
    }

    if (!error) {
      setRefetchCount(0);
    }
    // ignore refetchCount
  }, [retries, refetch, error]);
};
